import React, { useEffect, useState } from "react";
import Banner from "../../components/Banner";
import axios from "../../utils/request";
import { en, ch } from "../../utils/content";
import "./index.css";

const TantactPage = () => {
  const [tantact, setTantact] = useState<any>({});
  useEffect(() => {
    const initData = async () => {
      const res: any = await axios.get("/index/index/site");
      if (res.code === 200) {
        setTantact(res.data);
      }
    };
    initData();
  }, []);
  const lang = sessionStorage.getItem("lang") || "ch";
  const TXT_INFO = lang === "en" ? en : ch;
  return (
    <div className="tantact">
      <Banner />
      <div className="li">
        <div className="title">{TXT_INFO.telMe}</div>
        <div className="desc">
          <div className="d-li">
            {TXT_INFO.headOffice}：{tantact?.company_name}
          </div>
          <div className="d-li">
            {" "}
            {TXT_INFO.site}：{tantact?.address}
          </div>
          <div className="d-li">
            {TXT_INFO.phone}：{tantact?.phone}
          </div>
          <div className="d-li">
            {TXT_INFO.transmissionOfTruth}：{tantact?.fax}
          </div>
          <div className="d-li">
            {TXT_INFO.email}：{tantact?.email}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TantactPage;
